export default [
  {
    title: "Processo",
    link: "/servicos/cnc-process",
    sections: [],
  },
  {
    title: "Materiais",
    link: "/servicos/cnc-materiais",
    sections: [],
  },
  {
    title: "Instalações",
    link: "/servicos/cnc-instalacoes",
    sections: [],
  },
];

  